<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.80501 17.271C6.36274 17.271 5.951 17.0246 5.78916 16.6131C5.44113 15.728 5.25 14.764 5.25 13.7554C5.25 11.9334 5.87368 10.2571 6.91921 8.92834C7.0764 8.72855 7.30683 8.60649 7.5439 8.51471C8.03641 8.32403 8.47139 7.979 8.80635 7.5519C9.61173 6.52499 10.6268 5.67037 11.787 5.05247C12.5392 4.65186 13.192 4.05671 13.5085 3.26541C13.73 2.71172 13.8438 2.12086 13.8438 1.52452V0.864746C13.8438 0.433274 14.1935 0.0834961 14.625 0.0834961C15.9194 0.0834961 16.9688 1.13283 16.9688 2.42725C16.9688 3.62686 16.6984 4.76332 16.2152 5.77902C15.9386 6.36062 16.3267 7.11475 16.9707 7.11475H20.2268C21.2962 7.11475 22.2534 7.83766 22.3667 8.90106C22.4135 9.34088 22.4375 9.78751 22.4375 10.2397C22.4375 13.206 21.4043 15.931 19.6781 18.0744C19.2744 18.5757 18.6502 18.8335 18.0065 18.8335H13.8232C13.3194 18.8335 12.8188 18.7523 12.3409 18.5929L9.09664 17.5115C8.61867 17.3522 8.11815 17.271 7.61432 17.271H6.80501Z"
                :fill="color" 
            />
            <path
                d="M1.42863 9.17424C0.869589 10.5928 0.5625 12.1382 0.5625 13.7554C0.5625 15.0263 0.75217 16.2529 1.10475 17.4085C1.37491 18.2939 2.23352 18.8335 3.15926 18.8335H4.10487C4.56896 18.8335 4.85559 18.3145 4.65024 17.8983C4.03383 16.649 3.6875 15.2427 3.6875 13.7554C3.6875 11.976 4.18321 10.3124 5.04407 8.89522C5.29927 8.47507 5.01462 7.896 4.52304 7.896H3.42641C2.55972 7.896 1.7464 8.36791 1.42863 9.17424Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgLike',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>